window.importAngularDependencies = function (context, exclude = []) {
  if (typeof exclude === 'string') {
    exclude = [exclude];
  }
  const deps = [];
  context.keys().forEach((key) => {
    if (exclude.includes(key)) return;
    if (context(key).default && typeof context(key).default === 'string')
      deps.push(context(key).default);
  });
  return deps;
};
